import styled from "styled-components";
import ValueBackground from "/public/assets/images/career/value/value-bg.png"
import ValueMoBackground from "/public/assets/images/career/value/value-bg-mo.png"
import Logo from "/public/assets/images/logo/footer_logo.png"
import {getScroller, refreshOnAssetsReady, setupLenyStyle} from "@/app/homepage/utils";
import {useContext, useEffect, useRef} from "react";
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {LayoutContext} from "@/app/ClientRootHomepage";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";

gsap.registerPlugin(ScrollTrigger);

const Value = () => {
    const { rootRef } = useContext(LayoutContext);
    const wrapRef = useRef(null);
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;

        const scroller = getScroller(rootRef);
        const contentEl =
            scroller?.querySelector?.(".root") ||
            scroller?.firstElementChild ||
            scroller;

        const { cleanup } = setupLenyStyle({ wrap, scroller, contentEl });

        const triggers = [];
        const timelines = [];

        const circleContent = wrap.querySelector(".circle-content");
        const circleSection = wrap.querySelector(".circle-content .con");

        if (circleSection) {
            const circle = circleSection.querySelector(".circle");
            const lines = circle ? Array.from(circle.querySelectorAll(".line")) : [];

            if (circle && lines.length) {
                // ✅ will-change 제거
                gsap.set(lines, {
                    scale: 0.001,
                    opacity: 0,
                    transformOrigin: "50% 50%",
                });

                const tlLines = gsap.timeline({
                    paused: true,
                    onComplete: () => circleContent?.classList.add("add"),
                });

                tlLines.to(lines, {
                    scale: 1,
                    opacity: 1,
                    duration: 1.1,
                    ease: "expo.out",
                    stagger: { each: 0.2, from: "start" },
                    force3D: false, // ✅ 불필요한 3D 변환 방지
                });

                tlLines.eventCallback("onReverseComplete", () => {
                    circleContent?.classList.remove("add");
                });

                const stLines = ScrollTrigger.create({
                    trigger: circleSection,
                    start: "top 70%",
                    end: "top 45%",
                    toggleActions: "play none none reverse",
                    onEnter: () => tlLines.play(),
                    onEnterBack: () => tlLines.play(),
                    onLeaveBack: () => tlLines.reverse(),
                    scroller,
                });

                timelines.push(tlLines);
                triggers.push(stLines);
            }

            const cards = Array.from(
                circleSection.querySelectorAll("ul .circle-content-box .box-item .text-wrap")
            );

            if (cards.length) {
                // ✅ will-change 제거
                gsap.set(cards, {
                    y: 24,
                    opacity: 0,
                });

                const tlCards = gsap.timeline({ paused: true }).to(cards, {
                    y: 0,
                    opacity: 1,
                    duration: 0.7,
                    ease: "power3.out",
                    stagger: 0.15,
                    force3D: false, // ✅ 텍스트/원형 blur 방지
                });

                const stCards = ScrollTrigger.create({
                    trigger: circleSection.querySelector("ul") || circleSection,
                    start: "top 68%",
                    end: "top 45%",
                    toggleActions: "play none none reverse",
                    onEnter: () => tlCards.play(),
                    onEnterBack: () => tlCards.play(),
                    onLeaveBack: () => tlCards.reverse(),
                    scroller,
                });

                timelines.push(tlCards);
                triggers.push(stCards);
            }
        }

        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);

        const offAssets = refreshOnAssetsReady(wrap, () => {
            ScrollTrigger.refresh();
        });

        return () => {
            triggers.forEach((st) => st.kill());
            timelines.forEach((tl) => tl.kill());
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef]);



    return(
        <ValueWrap ref={wrapRef}>
            <TitleWrap>
                {
                    !isTablet ?

                        <div className={"text-box"}>
                            <h2>Mission</h2>
                            <p>
                                내 가족은 물론 국민의 건강과 생명을 보호하는 회사입니다.<br/>
                                회사와 구성원이 지속적으로 동반성장하는 회사입니다.<br/>
                                사회에 공헌하는 하나님의 기업입니다.
                            </p>
                        </div>
                        :
                        <div className={"mo-value-box"}>
                            <div className={"box-text-inner"}>
                                <h2>Mission</h2>
                                <p>
                                    내 가족은 물론<br/>
                                    국민의 건강과 생명을 보호하는 회사입니다.<br/>
                                    회사와 구성원이 지속적으로<br/>
                                    동반성장하는 회사입니다.<br/>
                                    사회에 공헌하는 하나님의 기업입니다.
                                </p>
                            </div>
                            <div className={"box-bg-inner"}>
                                <img src={ValueMoBackground?.src} alt={"배너 이미지"}/>
                            </div>
                        </div>
                }
            </TitleWrap>
            <div className={"circle-content"}>
                <div className="con">
                    <div className="circle">
                    <div className="logo"><img src={Logo?.src} alt=""/></div>
                        <p>Core Value</p>
                        <div className="line line1"></div>
                        <div className="line line2"></div>
                        <div className="line line3"></div>
                        <div className="line line4"></div>
                    </div>
                    <ul>
                        <li className="circle-content-box">
                            <div className={"box-item"}>
                                <div className={"text-wrap"}>
                                    <p>행복</p>
                                    <span>
                                        내가 행복해야<br/>
                                        동료와 회사도 행복합니다.
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li className="circle-content-box">
                            <div className={"box-item"}>
                                <div className={"text-wrap"}>
                                    <p>사람중심</p>
                                    <span>
                                        나는 언제나 사람을<br/>
                                        최우선으로 생각합니다.
                                    </span>
                                </div>
                            </div>
                            <div className={"line"}></div>
                        </li>
                        <li className="circle-content-box">
                            <div className={"box-item"}>
                                <div className={"text-wrap"}>
                                    <p>동반성장</p>
                                    <span>
                                        {
                                            !isTablet ?
                                             <>
                                                 우리의 성장은 회사의 성장이 되고<br/>
                                                 회사의 성장은 우리의 연봉으로 연결됩니다.
                                             </>
                                            :
                                                <>
                                                    우리의 성장은 회사의 성장이 되고<br/>
                                                    회사의 성장은 우리의 연봉으로<br/>
                                                    연결됩니다.
                                                </>
                                        }
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </ValueWrap>
    )
}
const ValueWrap = styled.div`
    position: relative;
    margin: 60px 0 0;
    overflow: hidden;
    .circle-content {
        //padding-top: 550px;
        margin-top: 150px;
        padding-bottom: 170px;

        .con{
            .circle{
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 400px;
                height: 400px;
                background: linear-gradient(180deg, #2E0B7E 0%, #0A0323 100%);
                border-radius: 999px;
                margin: 0 auto;
                p{
                    margin-top: 16px;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 36px;
                    letter-spacing: -0.02em;
                    color: #FFFFFF;
                }
                .logo{
                    width: 224px;
                }
                .line{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    border-radius: 50%;
                    &.line1{
                        width: 140%;
                        height: 140%;
                        background: #CDCCDC;
                        z-index: -1;
                    }
                    &.line2{
                        width: 200%;
                        height: 200%;
                        background: #DEDCEC;
                        z-index: -2;
                    }
                    &.line3{
                        width: 320%;
                        height: 320%;
                        background: #EBE9F4;
                        z-index: -3;
                    }
                    &.line4{
                        width: 420%;
                        height: 420%;
                        background: #efedf9;
                        z-index: -4;
                    }
                }
            }
            ul{
                margin-top: 120px;
                display: flex;
                justify-content: center;
                gap: 40px;   
                li{
                    position: relative;
                    width: 400px;
                    height: 400px;
                    border-radius: 50%;
                    background: #fff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    box-sizing: border-box;
                    //overflow: hidden;
                    &:nth-child(1)::after {
                        content: "";
                        position: absolute;
                        left: 100%;
                        bottom: calc(100% - 80px);
                        transform: rotate(45deg);
                        width: 1px;
                        height: 300px;
                        background: #271C7F;
                        z-index: -1;
                    }
                    
                    &:nth-child(2)::after {
                        content: "";
                        position: absolute;
                        left: 50%;
                        bottom: calc(100% - 80px);
                        width: 1px;
                        height: 300px;
                        background: #271C7F;
                        z-index: -1;
                    }
                    &:nth-child(3)::after {
                        content: "";
                        position: absolute;
                        right: 100%;
                        bottom: calc(100% - 80px);
                        transform: rotate(-45deg);
                        width: 1px;
                        height: 300px;
                        background: #271C7F;
                        z-index: -1;
                    }
                    .box-item{
                        position: relative;
                        width: 100%;
                        height: 100%;
                        .text-wrap{
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            gap: 24px;
                            p{
                                font-weight: 700;
                                font-size: 32px;
                                line-height: 48px;
                                text-align: center;
                                letter-spacing: -0.02em;
                                color: #4939B1;
                            }
                            span{
                                font-weight: 400;
                                font-size: 20px;
                                line-height: 32px;
                                text-align: center;
                                color: #333333;
                            }
                        }
               
                        &::after{
                            content:"";
                            position:absolute;
                            inset: 0;
                            border-radius: 50%;
                            background: conic-gradient(from -40deg, #271C7F 1%, #40DBA2 28%, #833494 66%, #6AC4E7 100%);
                            padding: 1px;
                            -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
                            -webkit-mask-composite: xor;
                            mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
                            mask-composite: exclude;
                            pointer-events: none;
                            z-index: 1;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        margin: 40px 0 0;
        .circle-content {
            &::before{
                content: "";
                width: 100%;
                height: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                background: #F3F2F9;
                z-index: -5;
            }
            padding-bottom: 160px;
            .con {
                .circle {
                    width: 260px;
                    height: 260px;
                    p {
                        margin-top: 16px;
                        font-size: 24px;
                        line-height: 36px;
                        letter-spacing: -0.02em;
                    }
                    .logo {
                        width: 184px;
                    }

                    .line {
                        &.line1 {
                            width: 160%;
                            height: 160%;
                        }

                        &.line2 {
                            width: 280%;
                            height: 280%;
                        }

                        &.line3 {
                            width: 420%;
                            height: 420%;
                        }

                        &.line4 {
                            width: 610%;
                            height: 610%;
                        }
                    }
                }

                ul {
                    margin-top: 72px;
                    flex-direction: column;
                    align-items: center;
                    gap: 40px;

                    li {
                        width: 240px;
                        height: 240px;
                        &:nth-child(1)::after {
                            left: 50%;
                            transform: rotate(0) translateX(-50%);
                        }

                        &:nth-child(2)::after {
                            display: none;
                        }

                        &:nth-child(3)::after {
                            display: none;
                        }

                        .box-item {
                            .text-wrap {
                                gap: 16px;
                                p {
                                    font-weight: 700;
                                    font-size: 20px;
                                    line-height: 30px;
                                    letter-spacing: -0.02em;
                                }
                                span {
                                    font-weight: 400;
                                    font-size: 16px;
                                    line-height: 24px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
const TitleWrap = styled.div`
    padding: 0 114px 0;
    //position: absolute;
    //top: 0;
    //left: 0;
    width: 100%;
    .text-box{
        border-radius: 20px;
        overflow: hidden;
        background: url(${ValueBackground?.src}) no-repeat center / cover;
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h2{
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            margin-bottom: 16px;
        }
        p{
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #E6E6E6;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 0;
        z-index: 20;
        background: #fff;
        .mo-value-box{
            .box-text-inner{
                text-align: center;
                margin-bottom: 40px;
                h2{
                    margin-bottom: 40px;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 36px;
                    letter-spacing: -0.02em;
                    color: #4939B1;
                }
                p{
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 28px;
                    color: #666666;
                }
            }
            .box-bg-inner{
                height: 152px;
                img{
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
`
export default Value